import React from 'react';
import {
  CTA,
  Features,
  Footer,
  Hero,
  HowItWorks,
  MultiplierEngine,
  MultiplierIntro,
  Navbar,
  Results,
  TrustStrip,
} from '@bright-web-skeleton/ui/kloutsale';
import {
  LandingPitchBlock,
  LandingInfoBlock,
  LandingExampleTabs,
  LandingInstructionBlock,
  kloutsaleHome,
} from '@bright-web-skeleton/ui';
import {
  benefits,
  footerColumns,
  heroStats,
  metrics,
  multiplierLevers,
  multiplierSteps,
  navLinks,
  steps,
  testimonials,
  trustItems,
} from './kloutsaleLandingContent';

export default function LandingPage() {
  return (
    <div className="min-h-[100dvh] bg-slate-950 text-white overflow-x-clip">
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute left-[-8rem] top-[-5rem] h-[24rem] w-[24rem] rounded-full bg-sky-500/15 blur-3xl" />
        <div className="absolute right-[-6rem] top-[8rem] h-[28rem] w-[28rem] rounded-full bg-blue-500/10 blur-3xl" />
        <div className="absolute bottom-[-8rem] left-[18%] h-[22rem] w-[22rem] rounded-full bg-cyan-400/8 blur-3xl" />
      </div>

      <Navbar navLinks={navLinks} />
      <main className="relative">
        <Hero trustItems={trustItems} heroStats={heroStats} />
        <TrustStrip />
        {/* Communication layer (Phase 2C) — pitch / info / examples */}
        <section className="mx-auto w-full max-w-6xl px-6 py-20 md:py-28">
          <LandingPitchBlock content={kloutsaleHome.pitch} tone="dark" />
          <div className="mt-16">
            <LandingInfoBlock content={kloutsaleHome.info} tone="dark" />
          </div>
          <div className="mt-16">
            <LandingExampleTabs examples={kloutsaleHome.examples} tone="dark" />
          </div>
        </section>
        <HowItWorks steps={steps} />
        <Features benefits={benefits} />
        <Results metrics={metrics} testimonials={testimonials} />
        <MultiplierIntro />
        <MultiplierEngine multiplierSteps={multiplierSteps} multiplierLevers={multiplierLevers} />
        {/* Communication layer (Phase 2C) — instruction block */}
        <section className="mx-auto w-full max-w-6xl px-6 py-20 md:py-28">
          <LandingInstructionBlock content={kloutsaleHome.instructions} tone="dark" />
        </section>
        <CTA />
      </main>
      <Footer footerColumns={footerColumns} />
    </div>
  );
}
